import { Entity } from "../helpers/Entity"

export type ItemCustomAttributeValues = {
    customAttributeValues: ItemCustomAttributeValue[]
}

export type ItemCustomAttributeValue = {
    customAttributeDefinitionId: string
    textValue?: string
    selectValue?:string[]
    label:string
    rowId: string
    required?: boolean
}

export type Image = {
    accountId: string
    bucket: string
    createdAt: string
    createdBy: string
    extension: string
    externalID: string
    fileName: string
    format: string
    integrationKey: string
    originalFileName: string
    originalFilePublicUrl: string
    originalHeight: number
    originalWidth: number
    publicUrl: string
    publicUrlBySize: object
    size: number
}

export type ProductCustomDefinitionWithValue = {
    id: string
    attributes: ItemCustomAttributeValue
    type: string
}

export type ProductCustomDefinitionImage = {
    id: string
    attributes: Image
    type: string
}

export type ProductCustomDefinitionImageMetadata = {
    id: string
    resources: Array<string> | null
    images: Array<ProductCustomDefinitionImage> | null
    label: string
    toDelete?: boolean
}

export type ProductCustomDefinitionAttributesLabel = {
    label: string
    metadata: Array<ProductCustomDefinitionImageMetadata>
}

export type ProductCustomDefinitionAttributesDto = {
    required: boolean
    label?: string //Deprecated, TBD
    allowMoreThanOneChoice: boolean
    customFieldDefinitionLabel: ProductCustomDefinitionAttributesLabel
    attributeType: string
    toDelete: boolean
}

export interface ProductCustomDefinitionAttributes extends ProductCustomDefinitionAttributesDto {
    id: string
    attributeType: string
    required: boolean
    toDelete: boolean
    allowMoreThanOneChoice: boolean
}

export interface ProductCustomDefinitionAttributesProps extends ProductCustomDefinitionAttributesDto {
    toDelete: boolean
    id: string
}

export type ProductCustomDefinitionDto = {
    id: string
    type: string
    attributes: ProductCustomDefinitionAttributesDto
}

export default class ProductCustomAttributeDefintion implements Entity {
    private dto: ProductCustomDefinitionDto
    constructor(dto: ProductCustomDefinitionDto) {
        this.dto = dto
    }
    isLoaded(): boolean {
        return this.dto.id != "" && this.dto.type == "product-custom-attribute-definitions"
    }

    getId(): string {
        return this.dto.id
    }

    getToDelete(): boolean {
        return this.dto.attributes.toDelete
    }

    deprecatedGetLabel(): string | undefined {
        return this.dto.attributes.label
    }

    getLabel(): ProductCustomDefinitionAttributesLabel {
        return this.dto.attributes.customFieldDefinitionLabel
    }

    getDeprecatedLabel(): string | undefined {
        return this.dto.attributes.label
    }

    getFieldType(): string {
        return this.dto.attributes.attributeType
    }

    isRequired(): boolean {
        return this.dto.attributes.required
    }

    allowMoreThanOneChoice(): boolean {
        return this.dto.attributes.allowMoreThanOneChoice
    }
}



// WEBPACK FOOTER //
// ./src/state/product-custom-attributes/CustomAttributeDefinition.ts